var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLevel2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#af9b5b;stroke-linecap:round;stroke-linejoin:round;}.cls-2{fill:#af975c;opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "niveau2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.54,27.74h-.88L9.77,35.63A7.53,7.53,0,0,0,7.55,41,9.33,9.33,0,0,1,10.18,38h0a3.6,3.6,0,0,1,3.54-3,3.74,3.74,0,0,1,1,.16,4.31,4.31,0,0,1,7.08-1.27v-2H16.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "23.68 35.44 23.68 35.44 23.68 35.44 23.68 35.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.78,35.63,32.64,23.5a7.56,7.56,0,0,0-5.16-2.22l.64,1.15H26.3l3,5.31H27l2.36,4.16H23.68v3a5.69,5.69,0,0,1,.83-.08,5.31,5.31,0,0,1,4.58,2.63h-.16A9.88,9.88,0,0,1,32.47,41H47A7.6,7.6,0,0,0,44.78,35.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.94,20.08a2.22,2.22,0,0,1-.18-4.43,2.73,2.73,0,0,1,4.57-2,2.71,2.71,0,0,1,.89,2.18,2.15,2.15,0,0,1,.8-.15,2.22,2.22,0,1,1,0,4.44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "26.95 27.74 29.3 31.9 16.18 31.9 18.54 27.74 16.18 27.74 19.19 22.43 17.35 22.43 22.74 12.9 28.12 22.43 26.29 22.43 29.3 27.74 26.95 27.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20,35.08c.62,0,1.22,0,1.81.09V33.92a4.28,4.28,0,0,0-3.11-1.34,4.32,4.32,0,0,0-4,2.61,3.68,3.68,0,0,0-1-.16,3.59,3.59,0,0,0-3.53,3A16.52,16.52,0,0,1,20,35.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.92,37.44h.16a5.3,5.3,0,0,0-4.58-2.63,5.56,5.56,0,0,0-.82.08v.55A15.76,15.76,0,0,1,28.92,37.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.68,35.44V31.9H21.8v3.27A18.9,18.9,0,0,1,23.68,35.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.46,41c-1.88-3.46-6.75-5.92-12.47-5.92S9.41,37.54,7.53,41Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 55,
    height: 55
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLevel2);
export default __webpack_public_path__ + "static/media/icon_level_2.95c94a009ad75bd63df2e39aefe04f05.svg";
export { ForwardRef as ReactComponent };